import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantContextService } from "../services/tenantcontext.service";
import { extractTenantFromLocation } from "../core/tenant.util";

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  private tenantService = inject(TenantContextService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tenant =
      (this.tenantService.getTenant()() || '').trim()
      || (window.localStorage.getItem('tenantContext') || '').trim()
      || (extractTenantFromLocation() || '').trim();

    // Request mit X-Customer-ID erweitern
    if (!tenant) return next.handle(req);

    return next.handle(req.clone({
      setHeaders: {
        'X-Customer-ID': tenant
      }
    }));
  }
}
